var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_410",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28884",
    "data-name": "Group 28884",
    transform: "translate(-4929 6212)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4929, -6212)",
    filter: "url(#Ellipse_410)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_410-2",
    "data-name": "Ellipse 410",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_5_",
    "data-name": "svgexport-17 (5)",
    transform: "translate(4949 -6195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49768",
    "data-name": "Path 49768",
    d: "M72.665.69A12.192,12.192,0,0,0,69.12,0a.512.512,0,0,0-.534.535A12.232,12.232,0,0,0,80.8,12.22Z",
    transform: "translate(-64.361 0)",
    fill: "#bee070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49769",
    "data-name": "Path 49769",
    d: "M136.757,21.689a12.236,12.236,0,0,0-8.141-11.53C128.858,16.587,132.409,21.687,136.757,21.689Z",
    transform: "translate(-120.312 -9.469)",
    fill: "#7ed65f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49770",
    "data-name": "Path 49770",
    d: "M258.643.159,248.454,12.221A12.232,12.232,0,0,0,260.671.536.512.512,0,0,0,260.138,0a12.292,12.292,0,0,0-1.5.158Z",
    transform: "translate(-232.006 0)",
    fill: "#348863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49771",
    "data-name": "Path 49771",
    d: "M258.622,2.338a12.175,12.175,0,0,0-2.051.531l-8.14,11.53c5.582,0,10.114-5.386,10.19-12.062Z",
    transform: "translate(-231.986 -2.179)",
    fill: "#39aa59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49772",
    "data-name": "Path 49772",
    d: "M256.556,10.158a12.236,12.236,0,0,0-8.141,11.53c4.347,0,7.9-5.1,8.141-11.53Z",
    transform: "translate(-231.97 -9.468)",
    fill: "#3dcc4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49773",
    "data-name": "Path 49773",
    d: "M18.512,209.831H6.927a.51.51,0,0,0-.424.792L12.091,219H24.9l-5.965-8.947a.51.51,0,0,0-.424-.227Z",
    transform: "translate(-6.417 -195.572)",
    fill: "#ffb13f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49774",
    "data-name": "Path 49774",
    d: "M235.3,209.831,218.415,219h12.81l5.588-8.382a.51.51,0,0,0-.424-.792Z",
    transform: "translate(-204.009 -195.572)",
    fill: "#ff6237"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49775",
    "data-name": "Path 49775",
    d: "M224.381,210.058,218.416,219h10.771l6.116-9.174H224.8a.51.51,0,0,0-.424.227Z",
    transform: "translate(-204.01 -195.572)",
    fill: "#ff893b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49776",
    "data-name": "Path 49776",
    d: "M313.711,299.831l-6.8,7.424,6.8,5.963h1.529a.51.51,0,0,0,.51-.51V299.831Z",
    transform: "translate(-286.495 -279.456)",
    fill: "#ff893b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49777",
    "data-name": "Path 49777",
    d: "M145.89,299.831l-7.475,7.424,7.475,5.963h10.771V299.831Z",
    transform: "translate(-129.445 -279.456)",
    fill: "#ffb13f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49778",
    "data-name": "Path 49778",
    d: "M59.915,299.831v12.878a.51.51,0,0,0,.51.51h12.3V299.831Z",
    transform: "translate(-56.28 -279.456)",
    fill: "#ffcf70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.9a2ac18fb098b15ce9f34accece1f1bf.svg";
export { ForwardRef as ReactComponent };